import { useState } from 'react';

const useFetch = (ajaxUrl) => {
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);

	const request = async (action, security, params = {}) => {
		setIsLoading(true);
		setError(null);

		const formData = new FormData();
		formData.append('action', action);
		formData.append('security', security);

		Object.keys(params).forEach(key => {
			if (typeof params[key] === 'object' && params[key] !== null) {
				formData.append(key, JSON.stringify(params[key]));
			} else {
				formData.append(key, params[key]);
			}
		});

		try {
			const response = await fetch(ajaxUrl, {
				method: 'POST',
				body: formData,
			});

			const result = await response.json();

			if (result.success) {
				return { success: true, data: result.data };
			} else {
				// Extract string message from error - API may return object or string
				let errorMsg = 'Request failed';
				if (result.data) {
					if (typeof result.data === 'string') {
						errorMsg = result.data;
					} else if (result.data.message) {
						errorMsg = result.data.message;
					} else if (result.data.error) {
						errorMsg = typeof result.data.error === 'string' ? result.data.error : JSON.stringify(result.data.error);
					} else {
						errorMsg = JSON.stringify(result.data);
					}
				}
				setError(errorMsg);
				return { success: false, error: errorMsg };
			}
		} catch (err) {
			const errorMsg = 'A network error occurred.';
			setError(errorMsg);
			return { success: false, error: errorMsg };
		} finally {
			setIsLoading(false);
		}
	};

	return { request, isLoading, error, setError };
};

export default useFetch;
